import {
  Box,
  Divider,
  Flex,
  Image,
  MediaBox,
  Picture,
  RatioContainer,
  Typography,
} from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

const HallmarkBox = styled(Box).attrs((props) => ({
  top: "44%",
  ...props,
}))`
  position: absolute;
  text-decoration: none;
  bottom: -2px;
  ${(props) => props.theme.mediaQueries.tablet`
    bottom: auto;
    top: 50%;
    transform: translateY(-50%);
  `}
`
const InfoLink = styled.a`
  text-decoration: underline;
`

const Hallmarking = () => (
  <Box contain>
    <Box px={{ desktop: "8%" }}>
      <Box my={5}>
        <MediaBox greaterThanOrEqual="tablet">
          <Image
            alt=""
            lazyload={false}
            mx="auto"
            src={require("images/leefiori/info/hallmarking/yourjewelleryyourway-desktop.svg")}
            width={{ desktop: "50%", tablet: "70%" }}
          />
        </MediaBox>
        <MediaBox lessThan="tablet">
          <Image
            alt=""
            lazyload={false}
            mx="auto"
            src={require("images/leefiori/info/hallmarking/yourjewelleryyourway-mobile.svg")}
            width="80%"
          />
        </MediaBox>
      </Box>
      <RatioContainer
        mb={{ _: 8, tablet: 9 }}
        pb={{
          _: "141.6%",
          desktop: "39.2%",
          tablet: "39.5%",
        }}
      >
        <Box position="relative">
          <Picture
            alt="sale"
            fallback={require("images/leefiori/info/hallmarking/topbanner-desktop-2x.jpg")}
            lazyload={false}
            srcSet={[
              {
                media: "(max-width: 767px)",
                sizes: "100vw",
                srcSet: `
             ${require("images/leefiori/info/hallmarking/topbanner-mobile.jpg")} 375w,
           ${require("images/leefiori/info/hallmarking/topbanner-mobile-2x.jpg")} 750w
           `,
              },
              {
                media: "(min-width: 768px)",
                sizes: "100vw",
                srcSet: `
             ${require("images/leefiori/info/hallmarking/topbanner-desktop.jpg")} 974w,
             ${require("images/leefiori/info/hallmarking/topbanner-desktop-2x.jpg")} 1948w
           `,
              },
            ]}
            width="100%"
          />

          <HallmarkBox
            px={{ _: 3, tablet: "0px" }}
            right={{ desktop: "14%", tablet: "0%" }}
            textAlign="center"
            width={{ _: "100%", desktop: "450px", tablet: "420px" }}
          >
            <Typography
              fontSize={{ _: "26px", desktop: "26px", tablet: "22px" }}
              fontWeight="bold"
              mb={3}
            >
              HALLMARKING IS YOUR GUARANTEE
            </Typography>
            <Typography
              color="neutral"
              lineHeight="26px"
              mx="auto"
              width={{ tablet: "80%" }}
            >
              At Lee Fiori, we believe it is important for our jewellery to
              remain in qualified hands. As such, we have our all our jewellery
              hallmarked at the renowned and respected Edinburgh Assay Office
              (EAO), guaranteeing that our customers are getting nothing but the
              very best.
            </Typography>
          </HallmarkBox>
        </Box>
      </RatioContainer>
      <Flex
        alignItems="center"
        flexDirection={{ _: "column-reverse", tablet: "row" }}
        flexWrap="wrap"
        mb={{ _: 8, tablet: 9 }}
      >
        <Box
          flexBasis={{ _: "100%", tablet: "50%" }}
          px={{ _: 3, desktop: 6 }}
          textAlign="center"
        >
          <Typography
            fontSize={{ _: "26px", desktop: "26px", tablet: "22px" }}
            fontWeight="bold"
            mb={3}
            mt={{ _: 5, tablet: 0 }}
            px={{ _: "30px", desktop: "115px", tablet: "54px" }}
          >
            HALLMARKS & WHAT TO LOOK FOR
          </Typography>
          <Typography color="neutral" lineHeight="26px" mx="auto">
            Hallmarks are a series of marks stamped on jewellery or other
            precious metal items, that can only be applied by an independent
            Government-authorised Assay Office. At Lee Fiori, we take pride in
            the craftsmanship of our jewellery, and the Hallmark guarantees that
            the precious metal content used to make our jewellery is of the
            finest quality.
          </Typography>
        </Box>
        <Box flexBasis={{ _: "100%", tablet: "50%" }}>
          <Picture
            alt="sale"
            fallback={require("images/leefiori/info/hallmarking/hallmarks_desktop_2x.jpg")}
            lazyload={false}
            srcSet={[
              {
                media: "(max-width: 767px)",
                sizes: "100vw",
                srcSet: `
          ${require("images/leefiori/info/hallmarking/hallmarks_mobile.jpg")} 382w,
        ${require("images/leefiori/info/hallmarking/hallmarks_mobile_2x.jpg")} 764w
        `,
              },
              {
                media: "(min-width: 768px)",
                sizes: "100vw",
                srcSet: `
          ${require("images/leefiori/info/hallmarking/hallmarks_desktop.jpg")} 894w,
          ${require("images/leefiori/info/hallmarking/hallmarks_desktop_2x.jpg")} 1341w
        `,
              },
            ]}
            width="100%"
          />
        </Box>
      </Flex>
      <Flex
        alignItems="center"
        bg={{ _: "primaryColors.lighter[0]", tablet: "white" }}
        flexWrap="wrap"
        mb={{ _: 8, tablet: 9 }}
      >
        <Box
          bg="primaryColors.lighter[0]"
          flexBasis={{ _: "100%", tablet: "55%" }}
          mt={{ _: 3, tablet: 0 }}
          p={{ _: 3, desktop: 7 }}
        >
          <Typography color="neutral" lineHeight="26px" mb={2} mx="auto">
            <strong>
              The Hallmark stamped on your Lee Fiori {jewlr_t("terms.jewelry")}{" "}
              will be in an inconspicuous location, and will consist of at least
              three compulsory parts:
            </strong>
          </Typography>
          <Typography color="neutral" lineHeight="26px" mb={2} mx="auto">
            <strong>1. The Sponsor&apos;s Mark</strong> – This unique mark
            identifies the maker or sponsor who has sent the items to be
            hallmarked.
          </Typography>
          <Typography color="neutral" lineHeight="26px" mb={2} mx="auto">
            <strong> 2. The Fineness Mark</strong> – Denotes the fineness of the
            metal. The purity of the precious metal content is recorded in parts
            per 1000. For example, 14 karat gold jewellery must contain 585
            parts per 1000 of pure gold. Gold jewellery meeting this standard
            will be marked with 585 to denote 14 karat.
          </Typography>
          <Typography
            color="neutral"
            lineHeight="26px"
            mb={{ _: 2, tablet: 0 }}
            mx="auto"
          >
            <strong>3. The Assay Office Mark</strong> – Indicates which UK Assay
            Office tested and marked the item.
          </Typography>
        </Box>
        <Box flexBasis={{ _: "100%", tablet: "45%" }} pb={{ _: 3, tablet: 0 }}>
          <Picture
            alt="sale"
            display="block"
            fallback={require("images/leefiori/info/hallmarking/ring_desktop_2x.jpg")}
            lazyload={false}
            mx="auto"
            srcSet={[
              {
                media: "(max-width: 767px)",
                sizes: "100vw",
                srcSet: `
            ${require("images/leefiori/info/hallmarking/ring_mobile.jpg")} 374w,
          ${require("images/leefiori/info/hallmarking/ring_mobile_2x.jpg")} 748w
          `,
              },
              {
                media: "(min-width: 768px)",
                sizes: "100vw",
                srcSet: `
            ${require("images/leefiori/info/hallmarking/ring_desktop.jpg")} 684w,
            ${require("images/leefiori/info/hallmarking/ring_desktop_2x.jpg")} 1026w
          `,
              },
            ]}
            width={{ _: "70%", desktop: "70%", tablet: "90%" }}
          />
          <Typography
            color="neutral"
            lineHeight="26px"
            mb={{ _: 2, tablet: 0 }}
            mt={{ _: 4, desktop: 2, tablet: 4 }}
            mx="auto"
            px={{ _: 3, desktop: 7, tablet: 2 }}
            textAlign="center"
          >
            <strong>FROM LEFT: </strong>Our Sponsor&apos;s Mark, the Fineness
            Mark for 14kt gold, and The Assay Office Mark of Edinburgh.
          </Typography>
        </Box>
      </Flex>
      <Divider
        display={{ _: "none", tablet: "block" }}
        my={{ desktop: 8, tablet: 3 }}
      />

      <Flex
        alignItems="center"
        flexWrap="wrap"
        justifyContent="center"
        mb={{ _: 8, tablet: 9 }}
        pl={{ _: 0, desktop: 5 }}
      >
        <Box flexBasis={{ _: "100%", tablet: "40%" }}>
          <Picture
            alt="sale"
            fallback={require("images/leefiori/info/hallmarking/qns_desktop_2x.jpg")}
            lazyload={false}
            srcSet={[
              {
                media: "(max-width: 767px)",
                sizes: "100vw",
                srcSet: `
          ${require("images/leefiori/info/hallmarking/qns_mobile.jpg")} 375w,
        ${require("images/leefiori/info/hallmarking/qns_mobile_2x.jpg")} 750w
        `,
              },
              {
                media: "(min-width: 768px)",
                sizes: "100vw",
                srcSet: `
          ${require("images/leefiori/info/hallmarking/qns_desktop.jpg")} 540w,
          ${require("images/leefiori/info/hallmarking/qns_desktop_2x.jpg")} 810w
        `,
              },
            ]}
            width="100%"
          />
        </Box>

        <Box
          flexBasis={{ _: "100%", tablet: "60%" }}
          p={{ _: 3, desktop: 5 }}
          textAlign="center"
        >
          <Divider display={{ _: "block", tablet: "none" }} mb={5} mt={2} />

          <Typography
            fontSize={{ _: "26px", desktop: "26px", tablet: "22px" }}
            fontWeight="bold"
            my={3}
          >
            QUALITY AND SERVICE
          </Typography>
          <Typography color="neutral" lineHeight="26px" mb={2} mx="auto">
            In operation since 1457, the official Assay Office Mark of Edinburgh
            carefully tests and hallmarks precious metals to ensure their
            fineness and quality. The EAO has been committed to protecting
            consumers for more than 500 years, winning UK industry awards for
            its customer service and superior workmanship. Please visit the
            Edinburgh Assay Office to{" "}
            <InfoLink
              href="https://www.edinburghassayoffice.co.uk/"
              rel="noopener"
              target="_blank"
            >
              learn more
            </InfoLink>
            .
          </Typography>
          <Typography color="neutral" lineHeight="26px" mx="auto">
            Lee Fiori is a member of the Assay Assured scheme which was
            developed to protect online jewellery shoppers. All retailers signed
            up to the scheme are subject to website audits and agree that any
            problems with precious metals purchased will be independently
            resolved at no charge to the customer. Please visit Assay Assured to{" "}
            <InfoLink
              href="https://www.assayassured.co.uk/"
              rel="noopener"
              target="_blank"
              textD
            >
              learn more
            </InfoLink>
            .
          </Typography>
        </Box>
      </Flex>
    </Box>
  </Box>
)

export default Hallmarking
